import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';
import {
  ReadLandingPageDomain,
  UpdateLandingPageDomain,
} from '@tinct/core-api-models';
import { ApiError, tinctApi } from '../../api';

export type UpdateLandingPageDomainParams = {
  organizationId: string;
  data: UpdateLandingPageDomain;
};

export const updateLandingPageDomain = async (
  params: UpdateLandingPageDomainParams,
): Promise<ReadLandingPageDomain> => {
  return await tinctApi.landingPageDomain.updateLandingPageDomain(
    params.organizationId,
    params.data,
  );
};

/**
 * Register, replace, or retry the workspace landing-page domain (PUT).
 * Re-PUT of the same domain after `failed` restarts provisioning.
 */
export const useUpdateLandingPageDomain = (
  options?: Omit<
    UseMutationOptions<
      ReadLandingPageDomain,
      ApiError,
      UpdateLandingPageDomainParams
    >,
    'mutationFn'
  >,
) => {
  const { onSuccess, ...restOptions } = options || {};

  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateLandingPageDomain,
    onSuccess: (...args) => {
      queryClient.invalidateQueries({
        queryKey: ['landing-page-domain', args[1].organizationId],
      });
      // Registering/replacing the domain changes organizationPublishedUrl on pages.
      queryClient.invalidateQueries({ queryKey: ['landing-pages'] });
      onSuccess?.(...args);
    },
    ...restOptions,
  });
};
